import Box from '@mui/material/Box';
import { PieChart } from '@mui/x-charts/PieChart';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

const DONUT = {
  arcLabel: 'value',
  innerRadius: 30,
  outerRadius: 100,
};

const PieBase = ({ title, data, donut }) => {
  const { palette } = useTheme();

  if (!data.length) return <Typography>No data to display</Typography>;
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        textAlign: 'center',
      }}
    >
      <Typography sx={{ fontSize: '1.25rem' }}>{title}</Typography>
      <PieChart
        series={[{ data, ...(donut ? DONUT : { arcLabel: 'value' }) }]}
        width={200}
        height={200}
        hideLegend={false}
        sx={{
          '&[class*="MuiChartsWrapper-root"]': {
            flex: '0 0 auto !important',
          },
        }}
        colors={[
          palette.info.main,
          palette.error.main,
          palette.warning.main,
          palette.secondary.main,
          palette.success.main,
          palette.primary.main,
        ]}
      />
    </Box>
  );
};

export default PieBase;
